import React from 'react';
import Input from '../../../../components/input/Input';
import Select from '../../../../components/input/Select';
import Button from '../../../../components/Button';
import { addAllItemToSelectList } from '../../../../lib/common';
import './BrandTierSelectorHeader.scss';

const BrandTierSelectorHeader = (props) => {
  const {
    currentTierList,
    brandTierSelector,
    setData,
    searchBrandTierSelectorList,
    resetBrandTierSelectorList,
    selectSelectorList,
    addSelectedItemToList,
  } = props;
  const { selectedList, selectedTier, filterOption } = brandTierSelector;
  const { storeName } = filterOption;

  return (
    <div className="brand-tier-selector-header">
      {/*브랜드 명 검색*/}
      <div className="selector-search-section">
        <Input
          size={'large'}
          placeholder={'브랜드명을 입력하세요'}
          onChange={(value) => {
            setData({
              path: ['brandTierSelector', 'filterOption', 'storeName'],
              value,
            });
          }}
          value={storeName}
        />

        <Button color="primary" text="검색" onClick={searchBrandTierSelectorList} />

        <Button color="light" text="초기화" onClick={resetBrandTierSelectorList} />
      </div>

      {/*전체선택/해제 버튼 및 선택 추가*/}
      <div className="selector-select-section">
        {/*전체선택/해제 버튼*/}
        <div className="selector-select-all-check-wrap">
          <Button color="primary" text="전체선택" onClick={() => selectSelectorList()} />

          <Button
            color="gray"
            text="전체해제"
            onClick={() => {
              /**
               *  추가하려고 선택한 브랜드 리스트를 전체 삭제
               */
              setData({
                path: ['brandTierSelector', 'selectedList'],
                value: [],
              });
            }}
          />
        </div>

        {/*티어 선택 및 선택 추가*/}
        <div className="selector-select-add-section">
          <Select
            className="selector-select"
            size="large"
            list={addAllItemToSelectList(currentTierList)}
            value={selectedTier}
            onChange={(value) => setData({ path: ['brandTierSelector', 'selectedTier'], value })}
          />

          <Button
            color="primary"
            text="선택 추가"
            disabled={!selectedTier || !selectedList.length}
            onClick={() => addSelectedItemToList()}
          />
        </div>
      </div>
    </div>
  );
};

export default BrandTierSelectorHeader;
